module.exports = __webpack_public_path__ + "img/emoji_35.71670883.png";